/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mLoading.vue?vue&type=template&id=72061d5c&scoped=true"
import script from "./mLoading.vue?vue&type=script&lang=js"
export * from "./mLoading.vue?vue&type=script&lang=js"
import style0 from "./mLoading.vue?vue&type=style&index=0&id=72061d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72061d5c",
  null
  
)

export default component.exports